.promptContainer {
  height: 354px;
  background: transparent;
  box-shadow: none;
  width: 356px;
  overflow: visible;
  display: grid;
  align-items: self-start;
  padding: 0;
}
